import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'
import { localserver, ROUTE_BASE_URL } from '../../api/common'
import { useHistory } from 'react-router-dom';
const UserContext = createContext(null)

export const UserProvider = ({ children }) => {
  const history = useHistory();
  const [adminName, setAdminName] = useState(
    localStorage.getItem('loginUserName') || ''
  )
  const [adminProfile, setAdminProfile] = useState(
    localStorage.getItem('loginUserImage') || ''
  )
  const [websiteName, setWebsiteName] = useState('AMASI')
  const [websiteLogo, setWebsiteLogo] = useState('')
  const [razorpayKey, setRazorpayKey] = useState('')
  const [eventUrl, setEventUrl] = useState('')
  const [sameState, setSameState] = useState(true)
  const [settingsDetails, setSettingsDetails] = useState({})
  const [buyerForm, setBuyerForm] = useState([]);
  const [regDetails,setregDetails]=useState({})

  const [validation, setValidation] = useState({
    success: false,
    can_publish: "No",
    message: "",
    validation: {},
  })

  const getValidation = async () => {
    try {
      const response = await axios.post(
        `${localserver}/publish_validation`,
        { event_id:localStorage.getItem("eventId") },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        setValidation(response.data)
      } else {
        console.error("Error: Failed to fetch validation data")
      }
    } catch (error) {
      console.error("Error fetching validation data:", error)
    }
  }

  const updateUser = (name, profile) => {
    setAdminName(name)
    if (profile !== null && profile !== '' && profile !== undefined) {
      setAdminProfile(profile)
    }
  }

  const fetchSettingsDetails = async (isMounted = true) => {
    try {
      const response = await axios.post(
        `${localserver}/getSettings`, 
        {
          event_id: localStorage.getItem('eventId')
        },
        {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })

      if (response.data.success && isMounted) {
        const details = response.data.data[0];
        const buyerForm = response.data.buyerForm;
        const regdetails = response.data.Customize_reg_details;
        // setWebsiteName(details.website_name)
        // setWebsiteLogo(`${baseUrl}/${details.logo}`)
        setregDetails(regdetails || {})
        setSettingsDetails(details)
        setBuyerForm(buyerForm || [])
        setSameState(response.data.state_is_same)
        setEventUrl(response.data.registration_url)
        // setRazorpayKey(details.razor_key_id)
      }
    } catch (error) {
      if (isMounted) console.error('Error fetching users data:', error)
    }
  }
  const checkPermission = async (moduleName, action) => {
    try {
      const response = await axios.post(
        `${localserver}/checkPermission`,
        { moduleName, action },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          },
          // Ensure we get the response body even for 401
          validateStatus: (status) => status < 500,
        }
      );
  
    
  
      if (response.status === 200 && response.data.success) {
        // Permission granted
        return true;
      } else {
        // Permission denied (401 or explicit false)
        console.error("Permission denied:", response.data.message);
        history.push(`${ROUTE_BASE_URL}/access-denied`);
        return false;
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return false;
    }
  };
  useEffect(() => {
    let isMounted = true
    fetchSettingsDetails(isMounted)
    getValidation()
    return () => {
      isMounted = false
    }
  }, [])

  return (
    <UserContext.Provider
      value={{
        razorpayKey,
        websiteName,
        websiteLogo,
        adminName,
        adminProfile,
        regDetails,
        updateUser,
        fetchSettingsDetails,
        settingsDetails,
        buyerForm,
        sameState,
        eventUrl,
        checkPermission,
        getValidation,
        validation
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => useContext(UserContext)
